import { LanguageContext } from 'contexts/LanguageContext';
import React, { useContext } from 'react';
import { IntlProvider } from 'react-intl';

interface Bitrix24IntlProviderProps {
  children: React.ReactNode;
}

export function Bitrix24IntlProvider({ children }: Bitrix24IntlProviderProps) {
  const { userLocale, dictionary } = useContext(LanguageContext);

  return (
    <IntlProvider
      locale={userLocale}
      messages={dictionary}
      defaultLocale="en-US"
    >
      {children}
    </IntlProvider>
  );
}
